<template>
	<div id="voucherPage" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div v-if="voucher != null && open" class="container h-100">
            <div class="row h-100 p-3 p-lg-4">
                <div class="col-md-6 col-lg-12 p-0 h-100 m-auto voucherHolder relative">
                    <div v-if="page == 'confirm'" class="header">
                    	<h3 class="m-auto text-orange">{{ $t('shop.shop_voucher_buy_title_confirm') }}</h3>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>
                    <div v-else class="header">
                    	<img :src="voucher.imageUrl" :alt="voucher.name"/>
                    	<small>{{ $t('shop.shop_voucher_buy_title_info') }}</small>
                    	<h2>{{ voucher.amount.toLocaleString('sr-RS') }}</h2>
                    	<b>{{ voucher.name }}</b>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>

                    <div v-if="!edit && page == 'form' && user.diamonds < voucher.price" class="noResourcesToBuy text-center">
                		<div class="w-100 mt-auto mb-auto p-3">
                			<h1 class="text-danger"><img src="/images/diamond.png" class="mr-2" /> <b>{{ user.diamonds.abbr() }}</b></h1>
                			<h3>{{ $t('shop.shop_voucher_buy_no_resorces_text') }}</h3>
                			<div class="w-100 mt-4 mb-3">
			                    <b-button @click="hide();btnSfx();" variant="primary" size="lg" class="pl-4 pr-4">{{ $t('base.btn_ok') }}</b-button>
		                    </div>
                		</div>
            		</div>

                    <div v-if="page == 'form'" class="voucherContent p-3">
                    	
                    	<p>{{ voucher.description }}</p>
                    	<b-form @submit.prevent="onSubmit">
                    		<fieldset :disabled="user.diamonds < voucher.price">
	                    	<div class="row p-lg-5">
	                    		<div class="col-lg-6">

		                    		<div class="form-group">
		                    			<label>{{ $t('shop.shop_voucher_buy_full_name_label') }} <span v-if="$v.form.fullName.$params.required">*</span></label>
								    	<b-form-input v-model="$v.form.fullName.$model" :state="validateState('fullName')"></b-form-input>
								    </div>

								    <div class="form-group">
		                    			<label>{{ $t('shop.shop_voucher_buy_email_label') }} <span v-if="$v.form.email.$params.required">*</span></label>
								    	<b-form-input v-model="$v.form.email.$model" :state="validateState('email')" type="email"></b-form-input>
								    </div>

		                    		<div class="form-group">
		                    			<label>{{ $t('shop.shop_voucher_buy_personal_number_label') }} <span v-if="$v.form.personalNumber.$params.required">*</span></label>
								    	<b-form-input v-model="$v.form.personalNumber.$model" type="number" :state="validateState('personalNumber')"></b-form-input>
								    </div>

								    <div class="form-group row">
								    	<div class="col-7">
								    		<label>{{ $t('shop.shop_voucher_buy_street_name_label') }} <span v-if="$v.form.streetName.$params.required">*</span></label>
								    		<b-form-input v-model="$v.form.streetName.$model" :state="validateState('streetName')"></b-form-input>
								    	</div>
								    	<div class="col-5">
								    		<label>{{ $t('shop.shop_voucher_buy_street_number_label') }} <span v-if="$v.form.streetNumber.$params.required">*</span></label>
								    		<b-form-input v-model="$v.form.streetNumber.$model" :state="validateState('streetNumber')"></b-form-input>
								    	</div>
								    </div>

							    </div>
	                    		<div class="col-lg-6">

								    <div class="form-group row">
								    	<div class="col-4">
								    		<label>{{ $t('shop.shop_voucher_buy_street_subnumber_label') }} <span v-if="$v.form.streetSubnumber.$params.required">*</span></label>
								    		<b-form-input v-model="$v.form.streetSubnumber.$model" :state="validateState('streetSubnumber')"></b-form-input>
								    	</div>
								    	<div class="col-4">
								    		<label>{{ $t('shop.shop_voucher_buy_floor_number_label') }} <span v-if="$v.form.floorNumber.$params.required">*</span></label>
								    		<b-form-input v-model="$v.form.floorNumber.$model" :state="validateState('floorNumber')"></b-form-input>
								    	</div>
								    	<div class="col-4">
								    		<label>{{ $t('shop.shop_voucher_buy_apartment_number_label') }} <span v-if="$v.form.apartmentNumber.$params.required">*</span></label>
								    		<b-form-input v-model="$v.form.apartmentNumber.$model" :state="validateState('apartmentNumber')"></b-form-input>
								    	</div>
								    </div>

								    <div class="form-group">
		                    			<label>{{ $t('shop.shop_voucher_buy_place_label') }} <span v-if="$v.form.place.$params.required">*</span></label>
								    	<b-form-input v-model="$v.form.place.$model" :state="validateState('place')"></b-form-input>
								    </div>

								    <div class="form-group mb-4">
		                    			<label>{{ $t('shop.shop_voucher_buy_municipality_label') }} <span v-if="$v.form.municipality.$params.required">*</span></label>
								    	<b-form-input v-model="$v.form.municipality.$model" :state="validateState('municipality')"></b-form-input>
								    </div>

								    <div class="form-group text-left">
								    	<b-form-checkbox v-model="$v.form.terms.$model" :state="validateState('terms')">
									    	<div>{{ $t('shop.shop_voucher_buy_privacy_label') }}</div>
									    	<div v-html="$t('base.link_terms_and_privacy')"></div>
									    </b-form-checkbox>
									</div>

								</div>
                    		</div>

							<div v-if="edit" class="w-100 mt-4 mb-3">
			                    <b-button type="submit" variant="primary" class="pl-4 pr-4">{{ $t('base.btn_continue') }}</b-button>
		                    </div>

	                    	<div v-if="!edit" class="w-100 mt-4 mb-3">
			                    <b-button type="submit" @click="btnSfx" variant="primary">
			                        <img src="/images/diamond.png" class="mr-2" />
			                        {{ voucher.price.toLocaleString('sr-RS') }}
			                    </b-button>
		                    </div>
		                    <div v-if="!edit" class="w-100 mb-2">
			                    <a href="#" @click="hide(); btnSfx();">{{ $t('base.btn_cancel') }}</a>
		                    </div>
                    	
	                    	</fieldset>
                    	</b-form>
                    </div>

                    <div v-if="page == 'confirm'" class="voucherContent">

                    	<div class="confirmRow">
                			<label>{{ $t('shop.shop_voucher_buy_full_name_label') }}</label>
                    		<p class="mb-0">{{ form.fullName }}</p>
                    	</div>

                    	<div class="confirmRow">
                			<label>{{ $t('shop.shop_voucher_buy_email_label') }}</label>
                    		<p class="mb-0">{{ form.email }}</p>
                    	</div>

                		<div class="confirmRow">
                			<label>{{ $t('shop.shop_voucher_buy_personal_number_label') }}</label>
                    		<p class="mb-0">{{ form.personalNumber }}</p>
                    	</div>

                    	<div class="confirmRow row">
					    	<div class="col-7">
                				<label>{{ $t('shop.shop_voucher_buy_street_name_label') }}</label>
                    			<p class="mb-0">{{ form.streetName }}</p>
                    		</div>
                    		<div class="col-5">
                    			<label>{{ $t('shop.shop_voucher_buy_street_number_label') }}</label>
                    			<p class="mb-0">{{ form.streetNumber }}</p>
                    		</div>
                    	</div>

					    <div class="confirmRow row">
					    	<div class="col-4">
					    		<label>{{ $t('shop.shop_voucher_buy_street_subnumber_label') }}</label>
					    		<p class="mb-0">{{ form.streetSubnumber != '' ? form.streetSubnumber : '-' }}</p>
					    	</div>
					    	<div class="col-4">
					    		<label>{{ $t('shop.shop_voucher_buy_floor_number_label') }}</label>
					    		<p class="mb-0">{{ form.floorNumber != '' ? form.floorNumber : '-' }}</p>
					    	</div>
					    	<div class="col-4">
					    		<label>{{ $t('shop.shop_voucher_buy_apartment_number_label') }}</label>
					    		<p class="mb-0">{{ form.apartmentNumber != "" ? form.apartmentNumber : '-' }}</p>
					    	</div>
					    </div>

					    <div class="confirmRow">
                			<label>{{ $t('shop.shop_voucher_buy_place_label') }}</label>
                    		<p class="mb-0">{{ form.place }}</p>
                    	</div>

                    	<div class="confirmRow">
                			<label>{{ $t('shop.shop_voucher_buy_municipality_label') }}</label>
                    		<p class="mb-0">{{ form.municipality != "" ? form.municipality : '-' }}</p>
                    	</div>

                    	<div class="w-100 p-3">
                    		<i class="fas fa-exclamation-triangle text-orange mb-2" style="font-size: 2rem;"></i>
                    		<div class="pl-4 pr-4"><b>{{ $t('shop.shop_voucher_buy_descriptin_confirm') }}</b></div>
                    	</div>

						<div class="w-100">
			                <b-button @click="page = 'form'; btnSfx();" type="button" variant="danger">
		                    	<i class="fas fa-arrow-left"></i> {{ $t('shop.shop_voucher_buy_confirm_back_btn') }}
		                    </b-button>
			                <b-button @click="confirm(); btnSfx();" type="button" variant="primary">
		                    	<i class="fas fa-check"></i> {{ $t('shop.shop_voucher_buy_confirm_btn') }}
		                    </b-button>
		                </div>

		                <p v-if="!edit" class="p-3">{{ $t('shop.shop_voucher_buy_confirm_info_value', { price: voucher.price.toLocaleString('sr-RS'), amount: voucher.amount.toLocaleString('sr-RS')}) }}</p>
                    </div>

                    <div v-if="page == 'info'" class="voucherContent p-3 p-lg-5">

                    	<h2 class="text-center mb-4"><b>{{ $t('shop.shop_voucher_buy_info_title') }}</b></h2>

                    	<div class="row mb-4 text-left">
                    		<div class="col-6">
                    			<h5>{{ $t('shop.shop_voucher_info_date_label') }}</h5>
                    		</div>
                    		<div class="col-6">
                    			<h5 class="text-primary"><b>{{ moment(voucher.date).format('DD.MM.YYYY') }}</b></h5>
                    		</div>
                    		<div class="col-6">
                    			<h5>{{ $t('shop.shop_voucher_info_state_label') }}</h5>
                    		</div>
                    		<div class="col-6">
                    			<h5 :class="'textChequeStatus_'+voucher.status">
                    				<b>{{ $t('shop.voucher_item_status_'+voucher.status)}}</b>
                    			</h5>
                    		</div>
                    	</div>

                    	<p class="text-justify">{{ $t('shop.shop_voucher_info_descriptin_'+voucher.status)}}</p>

                    	<div class="bottomAction mb-2">
                    		<b-button v-if="voucher.status == 'ERROR'" @click="openEditForm(); btnSfx();" type="button" variant="primary" class="pr-4 pl-4">{{ $t('shop.shop_voucher_info_edit_btn') }}</b-button>
                    		<b-button v-else @click="hide(); btnSfx();" type="button" variant="primary" class="pr-5 pl-5">{{ $t('base.btn_ok') }}</b-button>
                    	</div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import api from '../api'

import { validationMixin } from "vuelidate";
import { required, minLength, maxLength, numeric } from "vuelidate/lib/validators";


const VoucherPopup = Vue.component('voucher-popup', {
	mixins: [validationMixin],
    data() {
        return {
            page: 'form',
            voucher: null,
            payment: null,
            open: false,
            edit: false,
            form: {
            	fullName: '',
            	email: '',
            	personalNumber: '',
            	streetName: '',
            	streetNumber: '',
            	streetSubnumber: '',
            	floorNumber: '',
            	apartmentNumber: '',
            	place: '',
            	municipality: '',
            	terms: false
            }
        }
    },

    validations() {

	   	const rules = {
		    form: {
		   		fullName: {
		   			required,
		   			minLength: minLength(3)
		   		},
		   		streetName: {
		   			required,
		   			maxLength: maxLength(200)
		   		},
		   		streetNumber: {
					required,
					maxLength: maxLength(10)
		   		},
		   		streetSubnumber: {
					maxLength: maxLength(10)
		   		},
		   		floorNumber:{
					maxLength: maxLength(10)
		   		},
		   		apartmentNumber:{
					maxLength: maxLength(10)
		   		},

		   		email: {
		   			required,
		   		},

			    personalNumber: {
			    	required,
			    	numeric,
		    		minLength: minLength(13),
		    		maxLength: maxLength(13)
			    },

			    place: {
			    	required,
		    		maxLength: maxLength(50)
			    },

			    municipality: {
		    		maxLength: maxLength(50)
			    },

			    terms: {
			      accepted: val => val === true
			    }
		    }
		};

        return rules;

  	},

  	computed:{
  		user() {
            return this.$store.state.auth.user;
        },
  	},

  	methods: {

  		btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

	    validateState(name) {
	    	const { $dirty, $error } = name.split('.').reduce((r, val) => { return r ? r[val] : undefined; }, this.$v.form);
	    	return $dirty ? !$error : null;
	    },

	    resetForm() {
	    	this.form = {
	    		fullName: '',
            	email: '',
            	personalNumber: '',
            	streetName: '',
            	streetNumber: '',
            	streetSubnumber: '',
            	floorNumber: '',
            	apartmentNumber: '',
            	place: '',
            	municipality: '',
            	terms: false,
	    	};

	    	this.$nextTick(() => {
	    		let myDiv = document.querySelector('.voucherHolder .voucherContent');
				if(myDiv != undefined) myDiv.scrollTop = 0;
	    		this.$v.$reset();
	    	});
	    },

	    onSubmit() {
	    	this.$v.form.$touch();
	    	if (this.$v.form.$anyError) 
	    		return;

	    	this.page = 'confirm';
	    },

	    confirm(){
	    	const $this = this;
	    	this.$v.form.$touch();
	    	if (this.$v.form.$anyError) 
	    		return;

	    	let data = {...this.form};
	    	// remove empty
	    	for(let d in data)
	    		if(data[d] == "") data[d] = undefined;

	    	if(this.edit) data['paymentId'] = this.voucher.id;
	    	else data['voucherId'] = this.voucher.id;

	    	const request = this.edit ? api.updateVouchers(data) : api.shopBuyVouchers(data);
	    	request.then(response => {

	    		if(!$this.edit){
		    		$this.$root.$bvModal.msgBoxOk($this.$t('shop.shop_buy_success_voucher_text', { value: $this.voucher.amount.toLocaleString('sr-RS'), name: $this.voucher.name }), {
	                    title: $this.$t('shop.shop_buy_success_voucher_title'),
	                    size: 'sm',
	                    buttonSize: 'lg',
	                    okTitle: $this.$t('base.btn_ok'),
	                    modalClass: 'confirmModal',
	                    hideHeaderClose: false,
	                    centered: true
	                })
	                .then(r => {
		                $this.$store.dispatch('sound/sfx','Button');
		            });
	    		}

	    		$this.$emit('updated');
                $this.hide();

	    	})
	    	.catch(error => {
	    		api.baseErrorHendler(error);
	    	});

	    },

	    showBuyForm(obj) {
        	this.voucher = obj;
            this.page = 'form';
            this.open = true;
            this.edit = false;
            this.resetForm();
        },

        showInfo(obj) {
        	// fix for error prevent
        	obj.price = 0;

        	this.voucher = obj;
            this.page = 'info';
            this.edit = true;
            this.open = true;
            this.resetForm();
        },

        openEditForm(){
        	this.page = 'form';
            this.open = true;
            this.edit = true;
            this.resetForm();
        },

        hide() {
            this.open = false;
        },  
    },

    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        	document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        }
    }
})

export default VoucherPopup
</script>